import merge from 'lodash/merge';
import mergeDeep from '@utils/mergeDeep';
import {
  courseTypes,
  plusCoursesTypes,
  itemTypes,
  searchTypes
} from '../constants';

const initialState = {
  data: {},
  courseDetails: {},
  items: {},
  seeAllFeedEBInfo: {},
  relevantCourses: {},
  onboardingCourses: {},
  moreCoursesFilters: {},
  checkEnrollResults: [],
  enrolledCoursesFilters: {},
  similarPlusCourses: { type: `${plusCoursesTypes.FETCH_SIMILAR}_REQUEST` }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case courseTypes.UPDATE_COURSES:
      return {
        ...state,
        data: mergeDeep(action.data, state.data, 2)
      };

    case `${courseTypes.FETCH_COURSE_INFO}_SUCCESS`:
      return {
        ...state,
        courseDetails: {
          ...state.courseDetails,
          [action.courseUid]: action.result
        }
      };

    case `${courseTypes.TOGGLE_COURSE_ENROLLED}_SUCCESS`:
      return {
        ...state,
        data: {
          ...state.data,
          [action.courseUID]: merge(state.data[action.courseUID], {
            isEnrolled: action.enroll
          })
        }
      };

    case `${plusCoursesTypes.FETCH_SEE_ALL_EBINFO}_SUCCESS`:
      return {
        ...state,
        seeAllFeedEBInfo: {
          ...state.seeAllFeedEBInfo,
          [`${action.seeAllType}-${action.topologyUid}-${action.blockType}`]: action.result
        }
      };

    case `${plusCoursesTypes.FETCH_SEE_ALL_EBINFO}_FAILURE`:
      return {
        ...state,
        seeAllFeedEBInfo: {
          ...state.seeAllFeedEBInfo,
          [`${action.seeAllType}-${action.topologyUid}-${action.blockType}`]: {
            error: action.error
          }
        }
      };

    case `${courseTypes.FETCH_RELEVANT_COURSES}_SUCCESS`:
      return {
        ...state,
        relevantCourses: {
          ...state.relevantCourses,
          [action.courseUID]: action.result
        }
      };

    case `${searchTypes.FETCH_SEARCH_LIST}_SUCCESS`:
      return {
        ...state,
        searchFilters: action.result.filters
      };

    case `${itemTypes.BOOKMARK_ITEM}_SUCCESS`:
      return {
        ...state,
        data: {
          ...state.data,
          [action.uid]: merge(state.data[action.uid], {
            isBookmarked: action.isBookmarked
          })
        }
      };

    case `${courseTypes.FETCH_ONBOARDING_RECOMMENDED_COURSES}_SUCCESS`:
      return {
        ...state,
        onboardingCourses: {
          ...state.onboardingCourses,
          [action.goalUid]: action.result
        }
      };

    case `${plusCoursesTypes.FETCH_SIMILAR}_REQUEST`:
      return {
        ...state,
        similarPlusCourses: {
          ...state.similarPlusCourses,
          type: `${plusCoursesTypes.FETCH_SIMILAR}_REQUEST`
        }
      };

    case `${plusCoursesTypes.FETCH_SIMILAR}_SUCCESS`:
      return {
        ...state,
        similarPlusCourses: {
          ...state.similarPlusCourses,
          type: `${plusCoursesTypes.FETCH_SIMILAR}_SUCCESS`,
          [action.key]: action.result
        }
      };

    case `${plusCoursesTypes.FETCH_NEXT_TRACK}_SUCCESS`:
      return {
        ...state,
        nextTrack: {
          ...state.nextTrack,
          [action.key]: action.result
        }
      };
    case `${courseTypes.FETCH_MORE_COURSES_FILTERS}_SUCCESS`: {
      return {
        ...state,
        moreCoursesFilters: {
          ...state.moreCoursesFilters,
          [action.goalUID]: action.result
        }
      };
    }
    case `${courseTypes.CHECK_COURSE_ENROLL}_SUCCESS`:
      return {
        ...state,
        checkEnrollResults: action.result
      };

    case `${courseTypes.FETCH_ENROLLED_COURSES_FILTERS}_SUCCESS`:
      return {
        ...state,
        enrolledCoursesFilters: action.result
      };

    default:
      return state;
  }
};

export default reducer;
